/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { MemberManagementCreateMemberRequest } from '../models/MemberManagementCreateMemberRequest';
import type { MemberManagementCreateMemberResponseApiRespoonse } from '../models/MemberManagementCreateMemberResponseApiRespoonse';
import type { MemberManagementDeleteMemberRequest } from '../models/MemberManagementDeleteMemberRequest';
import type { MemberManagementDeleteMemberResponseApiRespoonse } from '../models/MemberManagementDeleteMemberResponseApiRespoonse';
import type { MemberManagementEditMemberRequest } from '../models/MemberManagementEditMemberRequest';
import type { MemberManagementEditMemberResponseApiRespoonse } from '../models/MemberManagementEditMemberResponseApiRespoonse';
import type { MemberManagementGetNewEventNumberRequest } from '../models/MemberManagementGetNewEventNumberRequest';
import type { MemberManagementGetNewEventNumberResponseApiRespoonse } from '../models/MemberManagementGetNewEventNumberResponseApiRespoonse';
import type { MemberManagementListMemberRequest } from '../models/MemberManagementListMemberRequest';
import type { MemberManagementListMemberResponseApiRespoonse } from '../models/MemberManagementListMemberResponseApiRespoonse';
import type { MemberManagementShowMemberRequest } from '../models/MemberManagementShowMemberRequest';
import type { MemberManagementShowMemberResponseApiRespoonse } from '../models/MemberManagementShowMemberResponseApiRespoonse';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class MemberManagementMemberService {

    /**
     * 会員一覧
     * @param requestBody
     * @returns MemberManagementListMemberResponseApiRespoonse 正常レスポンス
     * @throws ApiError
     */
    public static adminMember(
        requestBody: MemberManagementListMemberRequest,
    ): CancelablePromise<MemberManagementListMemberResponseApiRespoonse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/admin/member',
            body: requestBody,
            mediaType: 'applicatin/json',
            errors: {
                400: `Fail to process.`,
                401: `fail to authentication`,
                419: `token mismatch`,
            },
        });
    }

    /**
     * 会員の新規登録
     * @param requestBody
     * @returns MemberManagementCreateMemberResponseApiRespoonse 正常レスポンス
     * @throws ApiError
     */
    public static adminMemberCreate(
        requestBody: MemberManagementCreateMemberRequest,
    ): CancelablePromise<MemberManagementCreateMemberResponseApiRespoonse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/admin/member/create',
            body: requestBody,
            mediaType: 'applicatin/json',
            errors: {
                400: `Fail to process.`,
                401: `fail to authentication`,
                419: `token mismatch`,
            },
        });
    }

    /**
     * 会員一覧
     * @param requestBody
     * @returns MemberManagementShowMemberResponseApiRespoonse 正常レスポンス
     * @throws ApiError
     */
    public static adminMemberShow(
        requestBody: MemberManagementShowMemberRequest,
    ): CancelablePromise<MemberManagementShowMemberResponseApiRespoonse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/admin/member/show',
            body: requestBody,
            mediaType: 'applicatin/json',
            errors: {
                400: `Fail to process.`,
                401: `fail to authentication`,
                419: `token mismatch`,
            },
        });
    }

    /**
     * 会員の更新
     * @param requestBody
     * @returns MemberManagementEditMemberResponseApiRespoonse 正常レスポンス
     * @throws ApiError
     */
    public static adminMemberEdit(
        requestBody: MemberManagementEditMemberRequest,
    ): CancelablePromise<MemberManagementEditMemberResponseApiRespoonse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/admin/member/edit',
            body: requestBody,
            mediaType: 'applicatin/json',
            errors: {
                400: `Fail to process.`,
                401: `fail to authentication`,
                419: `token mismatch`,
            },
        });
    }

    /**
     * 会員の削除
     * @param requestBody
     * @returns MemberManagementDeleteMemberResponseApiRespoonse 正常レスポンス
     * @throws ApiError
     */
    public static adminMemberDelete(
        requestBody: MemberManagementDeleteMemberRequest,
    ): CancelablePromise<MemberManagementDeleteMemberResponseApiRespoonse> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/admin/member/delete',
            body: requestBody,
            mediaType: 'applicatin/json',
            errors: {
                400: `Fail to process.`,
                401: `fail to authentication`,
                419: `token mismatch`,
            },
        });
    }

    /**
     * 抽選番号の自動採番
     * @param requestBody
     * @returns MemberManagementGetNewEventNumberResponseApiRespoonse 正常レスポンス
     * @throws ApiError
     */
    public static adminMemberNewEventNumber(
        requestBody: MemberManagementGetNewEventNumberRequest,
    ): CancelablePromise<MemberManagementGetNewEventNumberResponseApiRespoonse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/admin/member/new-event-number',
            body: requestBody,
            mediaType: 'applicatin/json',
            errors: {
                400: `Fail to process.`,
                401: `fail to authentication`,
                419: `token mismatch`,
            },
        });
    }

}
